import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { ToolbarSeparator, TOOLBAR_SPACING } from 'libs/editor/styles';
import { EditorToolbarButton } from 'libs/editor/views/toolbarButton';
import { LinkInput } from 'libs/editor/views/linkInput';

import { withConditional } from 'legacyComponents/hoc/conditional';

import { FloatedToolBar, FixedToolBar } from './toolbar.styled';

const ConditionalInput = withConditional(LinkInput);
const ButtonSet = withConditional(React.Fragment);

@observer
export class Toolbar extends React.Component {
  minWidth = 100;
  componentDidMount() {
    const { store } = this.props;
    const {
      toolbarStore: { buttons },
    } = store;
    /*
     * FIXME - Magic numbers are:
     * ToolbarSeparator, EditorToolbarButton widths and ToolbarStyle padding
     */
    this.minWidth = buttons.reduce(
      (acc, cur) => acc + (typeof cur !== 'object' ? 18 : 34),
      40,
    );
  }

  render() {
    const { store } = this.props;

    const {
      value,
      selection,
      toolbarStore: { buttons, inputActive },
    } = store;
    if (!store.component) return null;

    let component = store.component.parentElement.parentElement;

    let opacity = 0;
    let top = -10000;
    let left = -10000;
    let borderRadius = 46;
    let width = 'auto';
    let position = 'absolute';
    let marginTop = '-6px';
    const emptySelection = !(
      value.selection.anchor.offset - value.selection.focus.offset
    );
    if (store.toolbarAlwaysVisible) {
      if (store.toolbarStore.component) {
        // eslint-disable-next-line prefer-destructuring
        component = store.toolbarStore.component;
      }
      position = 'unset';
      opacity = 1;
      top = 0;
      left = 0;
      borderRadius = 0;
      width = '100%';
      marginTop = '0px';
    } else if (
      selection &&
      !emptySelection &&
      (inputActive || value.selection.isFocused)
    ) {
      opacity = 1;
      const componentRect = component.getBoundingClientRect();
      top = selection.top - componentRect.top - this.toolbar.offsetHeight;
      left =
        selection.left -
        componentRect.left -
        this.toolbar.offsetWidth / 2 +
        selection.width / 2;
      left = Math.max(left, -TOOLBAR_SPACING);
      left = Math.min(
        left,
        componentRect.width - this.toolbar.offsetWidth + TOOLBAR_SPACING,
      );
    }
    // To avoid overlap with chat-wrapper, we need to reset left to 0
    if (left < 0) left = 0;

    const ToolbarStyled = store.toolbarAlwaysVisible
      ? FixedToolBar
      : FloatedToolBar;

    return ReactDOM.createPortal(
      <ToolbarStyled
        ref={toolbar => {
          this.toolbar = toolbar;
        }}
        minWidth={this.minWidth}
        opacity={opacity}
        top={top}
        left={left}
        borderRadius={borderRadius}
        style={{ position, marginTop }}
        width={width}
      >
        <ConditionalInput condition={inputActive} store={store} />
        <ButtonSet condition={!inputActive}>
          {buttons.map((button, i) =>
            typeof button !== 'object' ? (
              <ToolbarSeparator key={i} />
            ) : (
              <EditorToolbarButton
                isFloating={!store.toolbarAlwaysVisible}
                key={button.type}
                store={store}
                button={button}
              />
            ),
          )}
        </ButtonSet>
      </ToolbarStyled>,
      component,
    );
  }
}

Toolbar.propTypes = {
  store: PropTypes.object,
};
